import React from "react";

// Setas que compõem o "X" da marca (Projeto Visual, págs. 11 e 12).
// variant="solid": preenchimento laranja (só sobre navy, como micro-elemento);
// variant="line": contorno pontilhado; variant="outline": contorno fino contínuo (sobre foto e vídeo).
// size="sm" | "md" | "lg" define a altura via CSS (ícones, progresso do formulário, grafismo grande).
export const ARROW_PATHS = [
  "M1019.59 554.59L846.43 795.39L780.00 795.39L963.92 543.56C965.57 541.30 965.57 538.18 963.92 535.83L780.00 284.00L847.21 284.00L1019.59 524.80C1026.01 533.75 1025.93 545.73 1019.59 554.59Z",
  "M1120.93 595.49L977.21 795.39L910.78 795.39L1074.47 571.26C1088.19 552.50 1088.19 526.97 1074.47 508.21L910.78 284.08L977.99 284.08L1121.10 483.90C1144.98 517.33 1144.98 562.23 1121.01 595.57Z",
];

const STROKES = {
  solid: { fill: "currentColor", stroke: "none", strokeWidth: 0 },
  line: { fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeDasharray: "2 5" },
  outline: { fill: "none", stroke: "currentColor", strokeWidth: 1.2 },
};

function GhxpArrows({ variant = "line", size = "lg", className = "" }) {
  return (
    <svg
      className={`ghxpArrows ghxpArrows--${variant} ghxpArrows--${size} ${className}`}
      viewBox="776 280 373 519"
      aria-hidden="true"
      focusable="false"
    >
      {ARROW_PATHS.map((d) => (
        <path key={d} d={d} {...STROKES[variant]} vectorEffect="non-scaling-stroke" />
      ))}
    </svg>
  );
}

export default GhxpArrows;
